/**
 * TODO: this is used to automatically clear a user's cache
 *
 * Should it be…
 * - frontend version?
 *  - too aggressive: that would clear the cache on every frontend deploy
 * - user/member id?
 *
 * Other things to consider:
 * - clear the cache when the user logs out
 */
// Bump this string to discard every persisted cache once. Needed because the pending-query
// bug fixed alongside this (see createPersistenceConfiguration) wrote flag-list entries with
// no `items`, and those entries outlive the fix: react-query drops a persisted entry only
// when the buster changes or it ages past `maxAge` (= frontend-query-cache-gc-time, up to
// 24h). Without a bump, everyone already holding a poisoned entry keeps rendering an empty
// flag list until it ages out.
export function createCacheBuster() {
  return 'launchdarkly-temporary-cache-buster-2';
}
